import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function Footer() {
  const [showLegal, setShowLegal] = useState(false);

  return (
    <footer className="border-t border-gray-200 mt-16 bg-gray-50">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-600 text-sm">
            © 2026 GE-ROOM SAS. Tous droits réservés.
          </div>
          <div className="flex items-center gap-6 text-sm">
            <a href="mailto:contact@ge-room.com" className="text-gray-600 hover:text-black transition-colors">
              contact@ge-room.com
            </a>
            <button
              onClick={() => setShowLegal(!showLegal)}
              className="flex items-center gap-1 text-gray-600 hover:text-black transition-colors"
            >
              Mentions Légales
              {showLegal ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
          </div>
        </div>
      </div>

      {/* Legal Section - Expandable */}
      {showLegal && (
        <div className="border-t border-gray-200 bg-white">
          <div className="max-w-7xl mx-auto px-6 py-12">
            {/* Mentions Légales */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">MENTIONS LÉGALES</h2>

              <div className="space-y-6 text-gray-700 text-sm leading-relaxed">
                <div>
                  <h3 className="font-semibold text-black mb-2">Éditeur du site</h3>
                  <p>
                    GE-ROOM, Société par actions simplifiée (SAS), immatriculée sous le numéro SIREN 985 342 963.<br />
                    SIRET (siège social) : 985 342 963 00016<br />
                    N° TVA intracommunautaire : FR73985342963<br />
                    Code APE / NAF : 5829C – Édition de logiciels applicatifs<br />
                    Date de création : 08 mars 2024<br />
                    Siège social : 8 Mail Victor Jarra, Bâtiment C1, 93160 Noisy-le-Grand, France<br />
                    Directeur de la publication : Haining WANG<br />
                    Contact : <a href="mailto:contact@ge-room.com" className="text-black underline">contact@ge-room.com</a>
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-black mb-2">Hébergement</h3>
                  <p>
                    Les Services sont hébergés sur l'infrastructure cloud Amazon Web Services (AWS).<br />
                    Hébergeur (entité couramment utilisée pour l'UE) : Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxembourg.<br />
                    <span className="text-gray-500 italic">Nota : l'entité exacte d'hébergement/contractante peut varier selon votre compte AWS (voir "AWS Billing / Legal entity" dans la console).</span>
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-black mb-2">Propriété intellectuelle</h3>
                  <p>
                    L'ensemble du site, des Services, du logiciel, des interfaces, textes, éléments graphiques, logos, marques, bases de données, ainsi que les contenus fournis par GE-ROOM, sont protégés par le droit de la propriété intellectuelle. Toute reproduction, représentation, adaptation ou exploitation, totale ou partielle, sans autorisation écrite préalable de GE-ROOM, est interdite.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-black mb-2">Responsabilité</h3>
                  <p>
                    GE-ROOM met en œuvre des moyens raisonnables pour assurer l'accès et le bon fonctionnement du site et des Services. Toutefois, GE-ROOM ne garantit pas une disponibilité continue ni l'absence d'erreurs ou d'interruptions. Les informations et résultats fournis via les Services sont fournis "en l'état" et ne constituent pas un engagement de résultat.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-black mb-2">Liens externes</h3>
                  <p>
                    Le site peut contenir des liens vers des sites tiers. GE-ROOM n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu et leurs pratiques.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-black mb-2">Données personnelles & cookies</h3>
                  <p>
                    Le traitement des données personnelles et l'utilisation des cookies/traceurs sont décrits dans la Politique de Confidentialité et la Politique Cookies accessibles sur le site (ou communiquées sur demande à <a href="mailto:contact@ge-room.com" className="text-black underline">contact@ge-room.com</a>).
                  </p>
                </div>
              </div>
            </section>

            {/* Conditions de Service */}
            <section>
              <h2 className="text-2xl font-bold text-black mb-6">CONDITIONS DE SERVICE & CONTRAT DE LICENCE</h2>

              <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
                <p>
                  En accédant au site et/ou en utilisant la plateforme GE-ROOM (les "Services"), vous reconnaissez avoir lu et accepté les présentes Conditions de Service et le Contrat de Licence (EULA).
                </p>
                <p>
                  Les Services sont concédés sous licence, non vendus. Sauf mention contraire, les Services sont fournis "tels quels" et "selon disponibilité". Les Résultats générés dépendent notamment des contenus fournis par l'utilisateur et peuvent comporter des approximations ; il appartient à l'utilisateur de les vérifier avant tout usage professionnel, commercial ou technique.
                </p>
                <p>
                  Pour toute question : <a href="mailto:contact@ge-room.com" className="text-black underline">contact@ge-room.com</a>
                </p>
              </div>
            </section>
          </div>
        </div>
      )}
    </footer>
  );
}
